// grp/grp.module.ts (Main feature module)
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Angular Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

// Routing
import { GrpRoutingModule } from './grp-routing.module';

// Components
import { NewsGrpComponent } from './grp_module/news-grp/news-grp.component';
import { MarkerGrpComponent } from './grp_module/marker-grp/marker-grp.component';
import { CategoryGrpComponent } from './grp_module/category-grp/category-grp.component';
import { AddEditNewsDialogComponent } from './grp_module/news-grp/add-edit-news-dialog/add-edit-news-dialog.component';
import { AddEditMarkerDialogComponent } from './grp_module/marker-grp/add-edit-marker-dialog/add-edit-marker-dialog.component';
import { AddEditCategoryDialogComponent } from './grp_module/category-grp/add-edit-category-dialog/add-edit-category-dialog.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [
    NewsGrpComponent,
    MarkerGrpComponent,
    CategoryGrpComponent,
    AddEditNewsDialogComponent,
    AddEditMarkerDialogComponent,
    AddEditCategoryDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GrpRoutingModule, // Import your routing module

    // Angular Material modules
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatPaginatorModule,
    MatTableModule,
    MatCheckboxModule,
  ],
})
export class GrpModule {}
